import * as tslib_1 from "tslib";
import { globalStateFilterOnOff, } from '@models';
import { ODataGridComponent, urlStateHandler, } from '@pages/generics/grid';
import { WebhookService } from '@services/webhook.service';
import { takeUntil } from 'rxjs/operators';
var ɵ0 = urlStateHandler;
var WebhooksPageComponent = /** @class */ (function (_super) {
    tslib_1.__extends(WebhooksPageComponent, _super);
    function WebhooksPageComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.enabledValues = globalStateFilterOnOff();
        _this.isWebhooksEditGranted$ = _this._appState.user.permissions.isGranted('Webhooks.Edit');
        return _this;
    }
    WebhooksPageComponent.prototype.editItem = function (item) {
        this._router.navigate(["/webhooks/edit/" + item.id]);
    };
    WebhooksPageComponent.prototype.handleEnabledToggle = function (entry, elem) {
        var _this = this;
        if (entry.enabled) {
            elem.checked = true;
            this._modal.onConfirm(null, function () {
                elem.checked = false;
                _this._setWebhookState(entry, false);
            }, function () { }, this._translate.instant('webhooks_grid_disable_confirmation', {
                url: entry.url,
            }));
        }
        else {
            elem.checked = true;
            this._setWebhookState(entry, true);
        }
    };
    WebhooksPageComponent.prototype._setWebhookState = function (entry, active) {
        var _this = this;
        this.loading$.next(true);
        entry.enabled = active;
        this._service
            .toggleEnabled(entry)
            .pipe(takeUntil(this._destroyed$)).subscribe(function () { return _this._refresh$.next(); }, function () { return _this._refresh$.next(); });
    };
    return WebhooksPageComponent;
}(ODataGridComponent));
export { WebhooksPageComponent };
export { ɵ0 };
